import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {NavLink} from 'react-router-dom';
import {withRouter} from 'react-router';

import NewsMenu from './NewsMenu.js';

const NewsMenuItem = ({ clang, name, children, match: {url} }) => {
    return (
        <li className="news__menu-list__item">
            <NavLink
                to={`/news/${name}`}
                title={lang[clang].news[name]}
                className="news__menu-list__item--btn">
                {lang[clang].news[name]}
                <span className="news__menu-list__item--img"></span>
            </NavLink>
            {children && children.length ? <NewsMenu items={children} /> : null}
        </li>
    );
};

NewsMenuItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(NewsMenuItem));



// WEBPACK FOOTER //
// ./src/components/news/NewsMenuItem.js